import React from "react";

const Footer = () => {
  return (
    <footer>
      designed and coded by{" "}
      <a href="https://github.com/sametweb" alt="samet mutevelli">
        samet mutevelli
      </a>{" "}
      | data:{" "}
      <a href="https://covid19api.com" alt="covid19 api">
        covid19api.com
      </a>
    </footer>
  );
};

export default Footer;
